import React from "react";
import Button from "../../../components/button/Button";
import BuyerInfo from "../Components/BuyerInfo/BuyerInfo";
import "./Modified.css";

const Modified = () => {
  return (
    <>
      <div className="modified__order">
        <BuyerInfo />

        <div className="mo__further">
          <p className="mo__para">
            You can now track the progress of your order in the{" "}
            <span>Order Tab.</span>
          </p>
        </div>
      </div>
      <Button text="DONE" />
    </>
  );
};

export default Modified;
